import React from 'react';
import { help_step_1, help_step_2, help_step_3, help_step_4, help_step_5 } from "../../assets/svgs-index";

class HelpDeleteAccount extends React.Component {

  render() {

    return (
      <React.Fragment>
        <div className="main-container w-100 h-100 mt-5">
          <div className="help-container">
            <h2>Como apagar a sua conta Keymaster Cliente associada a um prestador de serviços</h2>
            <h3 className="w-100 mt-4 mb-3 mt-5">1) Inicie sessão</h3>
            <img
              className="step-image-container mt-2"
              src={help_step_1}
              alt="help-step-1"
            />
            <h3 className="w-100 mt-4 mb-3 mt-6">2) Caso não seja direcionado automaticamente para o prestador de serviços onde pretende apagar a conta, selecione o prestador de serviços pretendido.</h3>
            <img
              className="step-image-container mt-2"
              src={help_step_2}
              alt="help-step-2"
            />
            <div className="w-100 mt-4 mb-3 mt-6"></div>
            <img
              className="step-image-container mt-2"
              src={help_step_3}
              alt="help-step-3"
            />
            <h3 className="w-100 mt-4 mb-3 mt-6">3) Abra o menu dados de cliente e escolha a opção "Apagar a minha Conta"</h3>
            <img
              className="step-image-container mt-2"
              src={help_step_4}
              alt="help-step-4"
            />
            <h3 className="w-100 mt-4 mb-3 mt-6">4) Confirme a ação de apagar conta</h3>
            <img
              className="step-image-container mt-2"
              src={help_step_5}
              alt="help-step-5"
            />
            <h3 className="w-100 mt-4 mb-2 mt-6">5) A sua conta será removida</h3>
            <div className="ps-3 pe-3 mb-5">
              Serão removidos da App Keymaster Cliente todos os dados relativos ao prestador de serviços escolhido.<br />
              Os dados de outros prestadores de serviço permanecerão intactos.
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  };
};

export default HelpDeleteAccount;
